export default "__VITE_ASSET__43970168__"